import { UpfrontPaymentMethod } from '@shared/enums/payment-type';
import { ContractType } from '@shared/enums/contract-type';
import { ShoppingCartResponse } from './order-capture.model';

export enum OrderStatus {
  Initialized = 'Initialized',
  Rejected = 'Rejected',
  Waiting = 'Waiting',
  InProgress = 'InProgress',
  ReadyToBeFinalized = 'ReadyToBeFinalized',
  Finalized = 'Finalized',
  Cancelled = 'Cancelled',
  Error = 'Error',
  Completed = 'Completed',
}

export enum ShippingStatus {
  ShippingNotRequired = 'ShippingNotRequired',
  NotYetShipped = 'NotYetShipped',
  Shipped = 'Shipped',
  Delivered = 'Delivered',
}

export enum PaymentStatus {
  Initiated = 'Initiated',
  Authorized = 'Authorized',
  Captured = 'Captured',
  Cancelled = 'Cancelled',
  Reversed = 'Reversed',
  Failed = 'Failed',
  Expired = 'Expired',
  Unknown = 'Unknown',
}

export class PaymentDetails {
  paymentId: string;
  status: PaymentStatus;
  paymentUrl: string;
  providerPaymentId: string;
}

export class PaymentCapture extends PaymentDetails {
  id: number;
  phone: string;
  hasSentPaymentInfo: boolean;
}

export class UpdatePaymentStatusResponse {
  paymentId: string;
  status: PaymentStatus;
  hasSentPaymentInfo: boolean;
}

export class CustomerCapture {
  id: number;
  existingCustomerId: string;
  ssn: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  streetAddress: string;
  postalCode: string;
  city: string;
  invoiceType: string;
  consentChecked: boolean;
  isExistingCustomer: boolean;
  fullName: string;
}

export class OrderCaptureItem {
  id: number;
  contractId: string;
  orderServiceId: number;
  existingCustomerId: string;
  upfrontPaymentMethod: UpfrontPaymentMethod;
  orderTotal: number;
  paidDateUtc: Date;
  shippingMethod: string;
  createdOnUtc: Date;
  cancelled: boolean;
  orderStatus: OrderStatus;
  shippingStatus: ShippingStatus;
  logisticsOrderId: string;
  paymentCapture: PaymentCapture;
  contractType: ContractType;
  contractSigned: boolean;
  customerCapture: CustomerCapture;
  isServiceOrder?: boolean;
  shoppingCart: ShoppingCartResponse;
  createdByClientId: string;
  createdByDealerId: string;
  createdByUserId: string;
  errorMessages: string[];
  productIdentifiers: ProductIdentifier[];
  bankIdVerification: BankIdVerificationResponse;
  bypassCategory?: BypassCategory;
}

export enum BypassCategory {
  BankId = 'BankId',
  Unknown = 'Unknown',
}

export class ProductIdentifier {
  id: string;
  identifierValue: string;
  identifierType: IdentifierType;
  isPendingUpdate: boolean;
  msisdn: string;
  orderId: string;
  createdOnUtc: Date;
  updatedPendingStatusUtc: Date;
}

export enum IdentifierType {
  IMEI = 'IMEI',
  GTIN = 'GTIN',
}

export class UpdateEquipmentRequest {
  actorId: string;
  items: UpdateEquipmentItem[];
}
export class UpdateEquipmentItem {
  msisdn: string;
  imei: string;
  gtin: string;
  orderServiceId: string;
  name: string;
}

export class BankIdVerificationResponse {
  id: string;
  verificationLinkCode: string;
  verificationStatus: BankIdStatus;
  confirmationTimestamp?: string;
  expiresAtUtc: string;
}

export enum BankIdStatus {
  Initiated = 'Initiated',
  AuthenticationReceivedButNotCompared = 'AuthenticationRecievedButNotCompared',
  Match = 'Match',
  Mismatch = 'Mismatch',
}
